export const mutations = {
  setProducts: (state, data) => (state.products = data),
  setGroups: (state, data) => (state.groups = data),
  setCategories: (state, data) => (state.categories = data),
  setSorts: (state, data) => (state.sorts = data),
  setPackings: (state, data) => (state.packings = data),
  setBrands: (state, data) => (state.brands = data),
}
